/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export enum AttributeNames {
  VERSION = 'nestjs.version',
  TYPE = 'nestjs.type',
  MODULE = 'nestjs.module',
  CONTROLLER = 'nestjs.controller',
  CALLBACK = 'nestjs.callback',
  PIPES = 'nestjs.pipes',
  INTERCEPTORS = 'nestjs.interceptors',
  GUARDS = 'nestjs.guards',
}
